import { BrandingThemeItem } from '@/types/brandingThemes';
import { SVTableRow } from '@/types/common';
import BrandingThemesDefaultThemeRadio from './BrandingThemesDefaultThemeRadio';
import { formatDateTimeFromUTC } from '@/utils/date';
import BrandingThemesManageMenu from './BrandingThemesManageMenu';
import { SVTable } from '@/components/core';

type BrandingThemesTableListProps = {
  showDefaultBrandingThemeRadio: boolean;
  brandingThemes?: BrandingThemeItem[];
};

export default function BrandingThemesTableList({
  showDefaultBrandingThemeRadio,
  brandingThemes,
}: BrandingThemesTableListProps) {
  const tableHeaders = [
    {
      content: 'Name',
      key: 'name',
    },
    {
      content: 'Last Updated',
      key: 'lastUpdated',
    },
    {
      content: 'Last Updated By',
      key: 'lastUpdatedBy',
    },
    {
      content: '',
      key: 'manage',
    },
  ];
  if (showDefaultBrandingThemeRadio) {
    tableHeaders.splice(3, 0, {
      content: 'Default Theme',
      key: 'default',
    });
  }

  const rows: SVTableRow[] = brandingThemes
    ? brandingThemes.map(theme => {
        const row: SVTableRow = {
          key: theme.uuid,
          cells: [
            { content: theme.name, type: 'text', key: 'name' },
            {
              content: formatDateTimeFromUTC(theme.lastUpdatedAt),
              type: 'text',
              key: 'lastUpdatedAt',
            },
            {
              content: theme.lastUpdatedBy.fullName,
              type: 'text',
              key: 'lastUpdatedBy',
            },
            {
              content: <BrandingThemesManageMenu theme={theme} />,
              type: 'custom',
              key: 'manage',
            },
          ],
        };

        if (showDefaultBrandingThemeRadio) {
          row.cells.splice(3, 0, {
            content: <BrandingThemesDefaultThemeRadio theme={theme} />,
            type: 'custom',
            key: 'default',
          });
        }

        return row;
      })
    : [];

  return (
    <SVTable
      headers={tableHeaders}
      ariaLabel="Branding Themes List"
      rows={rows}
      emptyTableContent="No branding themes have been set up"
    />
  );
}
